import { render, staticRenderFns } from "./mQues.vue?vue&type=template&id=677f911b&scoped=true&"
import script from "./mQues.vue?vue&type=script&lang=js&"
export * from "./mQues.vue?vue&type=script&lang=js&"
import style0 from "./mQues.vue?vue&type=style&index=0&id=677f911b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f911b",
  null
  
)

export default component.exports